<!-- Header with title/subtitle -->
<div
  class="hx-card__header"
  *ngIf="showHeader">
  <div class="hx-card__header-content">
    <h3
      class="hx-card__title"
      *ngIf="title() && !disabledTitle()">
      {{ title() }}
    </h3>
    <p
      class="hx-card__subtitle"
      *ngIf="subtitle() && !disabledSubtitle()">
      {{ subtitle() }}
    </p>
  </div>
  <div class="hx-card__header-divider"></div>
</div>

<!-- Content section -->
<div class="hx-card__content-wrapper">
  <ng-content></ng-content>
</div>
